// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"774e2053","239":"8842cf4e","453":"d456ce70","455":"1f8a6988","857":"1b3ddc68","977":"8c35837e"}[chunkId] + ".chunk.js";
};